import { render, staticRenderFns } from "./GoogleDriveBackupSettings.vue?vue&type=template&id=22354e50&scoped=true&"
import script from "./GoogleDriveBackupSettings.vue?vue&type=script&lang=js&"
export * from "./GoogleDriveBackupSettings.vue?vue&type=script&lang=js&"
import style0 from "./GoogleDriveBackupSettings.vue?vue&type=style&index=0&id=22354e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22354e50",
  null
  
)

export default component.exports